import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/avatar/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p>{`Avatars provide a container for displaying Entity or User images on Thumbtack. This component displays either the filled images after loading the image via URL or the blank Avatar view if there’s no backing image and initials are provided.`}</p>
    <div>
    <b>Entity</b>: a company, business, or service.
    </div>
    <div>
    <b>User</b>: a person or user.
    </div>
    <h2>{`Examples`}</h2>
    <h3>{`Initials`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`HStack {
    TPAvatar(url: nil, initials: "N")
        .tpAvatarTheme(.medium)
        .tpAvatarType(.entity)

    TPAvatar(url: nil, initials: "NC", isOnline: true)
        .tpAvatarTheme(.medium)
        .tpAvatarType(.user)
}
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/img/swiftui/avatar/tpavatar-example-1.png",
        "alt": "Initials example screenshot"
      }}></img></p>
    <h3>{`Image initializer / Custom theme`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`TPAvatar(image: Image(systemName: "car.circle.fill"), isOnline: true)
            .tpAvatarTheme(TPAvatarTheme(size: 96, badgeSize: 22, font: .callout))
            .tpAvatarType(.user)
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/img/swiftui/avatar/tpavatar-example-2.png",
        "alt": "Image init / theme customization example screenshot"
      }}></img></p>
    <h3>{`URL initializer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`HStack {
    TPAvatar(url: URL(string: "https://i.pravatar.cc/140"), isOnline: true)
        .tpAvatarTheme(.large)
        .tpAvatarType(.user)

    TPAvatar(url: URL(string: "https://i.pravatar.cc/140"), isOnline: true)
        .tpAvatarTheme(.large)
        .tpAvatarType(.entity)
}
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/img/swiftui/avatar/tpavatar-example-3.png",
        "alt": "URL initializer example screenshot"
      }}></img></p>
    <h2>{`Environment Values`}</h2>
    <h3><inlineCode parentName="h3">{`.tpAvatarType(_ style: TPAvatarType)`}</inlineCode></h3>
    <p>{`Either `}<inlineCode parentName="p">{`.user`}</inlineCode>{` or `}<inlineCode parentName="p">{`.entity`}</inlineCode></p>
    <h3><inlineCode parentName="h3">{`.tpAvatarTheme(_ theme: TPAvatarTheme)`}</inlineCode></h3>
    <p>{`Allows customization of the avatar look and feel. Defaults are provided for `}<inlineCode parentName="p">{`xSmall`}</inlineCode>{`, `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`, `}<inlineCode parentName="p">{`xLarge`}</inlineCode></p>
    <h2>{`Initializers`}</h2>
    <h3><inlineCode parentName="h3">{`public init(url: URL?, initials: String? = nil, isOnline: Bool = false)`}</inlineCode></h3>
    <p><strong parentName="p">{`url:`}</strong>{` - URL used to asynchronously load the avatar image`}</p>
    <h3><inlineCode parentName="h3">{`public init(image: Image, isOnline: Bool = false)`}</inlineCode></h3>
    <p><strong parentName="p">{`image:`}</strong>{` - Image used for the avatar`}</p>
    <h3><inlineCode parentName="h3">{`isOnline: Bool`}</inlineCode></h3>
    <p>{`Boolean value that controls whether the online badge is shown or not.`}</p>
    <h3><inlineCode parentName="h3">{`initials: String?`}</inlineCode></h3>
    <p>{`The initials to be shown when displaying the blank avatar. One character is used for .entity, and up to two characters can be used for .user styled avatars`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      